"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let MeterEditor = class MeterEditor extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    meter;
    onMeter(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("meter");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['formId', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                formId: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    noPrimaryButton: true,
                    closeButtonText: this.$fn.gettext("Close"),
                    size: "md",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("Meter", "Edit General Information"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_9428_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeComponent_9434_getActionArgs($event) {
        return {
            result: {
                ok: true,
                value: $event.data,
            },
        };
    }
    async act_1040167445267876_crud_9432_getActionArgs($event) {
        return {
            objectType: "meter",
            op: "upsert",
            data: this.meter,
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_9428 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_9428_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_9427 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_9428,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_9427],
        });
        const act_2248226175642056_closeComponent_9430 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_9429 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_9430,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_9429],
        });
        const act_1040167445267876_closeComponent_9434 = new core_1.actions.CloseComponentAction({
            actionArgs: this.act_1040167445267876_closeComponent_9434_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_9433 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeComponent_9434,
            event: "success",
            displayName: "closeComponent",
        });
        const act_1040167445267876_crud_9432 = new core_1.actions.CRUDAction({
            actionArgs: this.act_1040167445267876_crud_9432_getActionArgs,
            displayName: "save",
            events: [evh_1040167445267876_success_9433],
        });
        const evh_1040167445267876_submit_9431 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_crud_9432,
            event: "submit",
            displayName: "save",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_9431],
        });
        const act_1419464017721962_closeComponent_9436 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_9435 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeComponent_9436,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_9435],
        });
        return {
            act_7315092382398562_closeModal_9428,
            evh_7315092382398562_close_9427,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_9430,
            evh_2248226175642056_close_9429,
            evh_2248226175642056_close,
            act_1040167445267876_closeComponent_9434,
            evh_1040167445267876_success_9433,
            act_1040167445267876_crud_9432,
            evh_1040167445267876_submit_9431,
            evh_1040167445267876_submit,
            act_1419464017721962_closeComponent_9436,
            evh_1419464017721962_clickPreventStop_9435,
            evh_1419464017721962_clickPreventStop,
            save: act_1040167445267876_crud_9432,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
    }),
    __metadata("design:type", Object)
], MeterEditor.prototype, "meter", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('meter'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], MeterEditor.prototype, "onMeter", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], MeterEditor.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], MeterEditor.prototype, "onSize", null);
MeterEditor = __decorate([
    (0, vue_property_decorator_1.Component)()
], MeterEditor);
exports.default = MeterEditor;
vue_property_decorator_1.Vue.component("MeterEditor", MeterEditor);
